require('@fortawesome/fontawesome-free/css/all.css');
require('bootstrap');
require('bootstrap/scss/bootstrap.scss');
window.$ = window.jQuery = require('jquery');
require('jquery-ajax-unobtrusive/dist/jquery.unobtrusive-ajax');
require('jquery-validation/dist/jquery.validate');
require('jquery-validation-unobtrusive/dist/jquery.validate.unobtrusive.js');


import './Shared/common';
import './Shared/Components/Autocomplete/autocomplete';
import './Shared/Components/MultiSelectFilter/multi-select-filter';
import './Shared/Components/Pagination/pagination';
import './Shared/Components/ScrollButton/scroll-button';
import './Shared/Components/Sliders/sliders';
import './Filters/movie-filters';
import './Profile/profile';
import './Movie/movie';
import './Account/account';
import './Movies/movies';
import './Home/home';
